export class StockImage
{
    Id!: number;
    Name!: string;
    Url!: string;

    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }
}
